// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const fomantis: PokeData = {
  "id": 753,
  "name": "fomantis",
  "height": 3,
  "weight": 15,
  "base_experience": 50,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "growth",
    "razor-leaf",
    "solar-beam",
    "slash",
    "fury-cutter",
    "sweet-scent",
    "synthesis",
    "sunny-day",
    "ingrain",
    "leaf-blade",
    "x-scissor",
    "leafage"
  ],
  "moves": [
    "razor-leaf",
    "solar-beam",
    "synthesis",
    "sunny-day",
    "overgrowth",
    "vine-whip",
    "branch-poke",
    "flower-rush",
    "power-whip",
    "grassy-terrain",
    "aromatherapy",
    "energy-ball",
    "frenzy-plant"
  ],
  "evolution_chain": {
    "id": 388,
    "item": null,
    "species": [
      {
        "name": "fomantis",
        "order": 753,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lurantis",
        "order": 754,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 753,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "day",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 37.5,
    "speed": 35,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
